import { ColumnDetails } from '../../../../../../grid/types/common';
import { ChildGroupColumn, ChildGroupColumnKeys } from '../types';
import { html } from 'lit';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export function nameRenderer(rowData, columnDetails: ColumnDetails<ChildGroupColumn, ChildGroupColumnKeys>) {
  const peInfo = rowData.item as ProtectedEntity;
  const cellValue = Translator.translateProtectedEntityNameByType(
    peInfo[columnDetails.key],
    peInfo.type,
    Constants.ProductTypes.GRAVITY_ZONE_CLOUD
  );
  return html` <span class="cell-label">${cellValue}</span> `;
}

export function policyRenderer(rowData, columnDetails: ColumnDetails<ChildGroupColumn, ChildGroupColumnKeys>) {
  const rowItem = rowData.item as ProtectedEntity;
  let cellValue;
  if (rowItem.activePolicy !== undefined) {
    cellValue = rowItem.activePolicy.policyName;
  } else if (rowItem.assignedPolicy?.policyName) {
    cellValue = rowItem.assignedPolicy.policyName;
  } else {
    cellValue = '-';
  }

  return html` <span class="cell-label">${cellValue}</span> `;
}
